import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=1127fe02&"
import script from "./comments.vue?vue&type=script&lang=ts&"
export * from "./comments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports